import { render, staticRenderFns } from "./StokListesiFiyatGuncelle.vue?vue&type=template&id=8209b9e0"
import script from "./StokListesiFiyatGuncelle.vue?vue&type=script&lang=js"
export * from "./StokListesiFiyatGuncelle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports